module.exports = __webpack_public_path__ + "img/AL801-2-EN.fb5fa6b8.jpg";